// Recovered compiled webpack factory 76636. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { h: () => p });
  var n = r(60057),
    a = r(66941);
  let o = (e) => e instanceof Promise && !e[i],
    i = Symbol("chained PromiseLike");
  var s = r(16649);
  class l {
    constructor(e, t) {
      let r, n;
      ((r = e || new a.H()),
        (n = t || new a.H()),
        (this._stack = [{ scope: r }]),
        (this._isolationScope = n));
    }
    withScope(e) {
      let t,
        r = this._pushScope();
      try {
        t = e(r);
      } catch (e) {
        throw (this._popScope(), e);
      }
      return (0, s.Qg)(t)
        ? ((e, t, r) => {
            let n = e.then(
              (e) => (t(e), e),
              (e) => {
                throw (r(e), e);
              },
            );
            return o(n) && o(e)
              ? n
              : ((e, t) => {
                  let r = !1;
                  for (let n in e) {
                    if (n in t) continue;
                    r = !0;
                    let a = e[n];
                    "function" == typeof a
                      ? Object.defineProperty(t, n, {
                          value: (...t) => a.apply(e, t),
                          enumerable: !0,
                          configurable: !0,
                          writable: !0,
                        })
                      : (t[n] = a);
                  }
                  return (r && Object.assign(t, { [i]: !0 }), t);
                })(e, n);
          })(
            t,
            () => this._popScope(),
            () => this._popScope(),
          )
        : (this._popScope(), t);
    }
    getClient() {
      return this.getStackTop().client;
    }
    getScope() {
      return this.getStackTop().scope;
    }
    getIsolationScope() {
      return this._isolationScope;
    }
    getStackTop() {
      return this._stack[this._stack.length - 1];
    }
    _pushScope() {
      let e = this.getScope().clone();
      return (this._stack.push({ client: this.getClient(), scope: e }), e);
    }
    _popScope() {
      return !(this._stack.length <= 1) && !!this._stack.pop();
    }
  }
  function u() {
    let e = (0, n.EU)(),
      t = (0, n.Se)(e);
    return (t.stack =
      t.stack ||
      new l(
        (0, n.BY)("defaultCurrentScope", () => new a.H()),
        (0, n.BY)("defaultIsolationScope", () => new a.H()),
      ));
  }
  function c(e) {
    return u().withScope(e);
  }
  function f(e, t) {
    let r = u();
    return r.withScope(() => ((r.getStackTop().scope = e), t(e)));
  }
  function d(e) {
    return u().withScope(() => e(u().getIsolationScope()));
  }
  function p(e) {
    let t = (0, n.Se)(e);
    return t.acs
      ? t.acs
      : {
          withIsolationScope: d,
          withScope: c,
          withSetScope: f,
          withSetIsolationScope: (e, t) => d(t),
          getCurrentScope: () => u().getScope(),
          getIsolationScope: () => u().getIsolationScope(),
        };
  }
}
